import Utils from './index'

const pushToExternalRoute = (router) => (url) =>
  Utils.iframeUtils.isIframe()
    ? Utils.iframeUtils.iframeRedirection(url)
    : router.push(url)

export default pushToExternalRoute
